export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN; // put it in common .env file

export const STAGE = process.env.REACT_APP_STAGE;
export const REGION = process.env.REACT_APP_REGION;

export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
export const USER_POOL_WEB_CLIENT_ID = process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID;
export const AWS_IMAGE_URL = process.env.REACT_APP_AWS_IMAGE_URL;

const LOCAL_EMAIL_NOTIFICATION_DEFAULT = 'http://localhost:3000';
const LOCAL_PLATFORM_LOGIN_URL = 'http://localhost:3000/login';

const isLocalPihApi = () => {
  const base = (process.env.REACT_APP_BASE_URL || '').trim();
  return base.includes('localhost') || base.includes('127.0.0.1');
};

/** Email notification service (OTP, reset-password-link, invites). Uses localhost when PIH API is local. */
export const EMAIL_NOTIFICATION_URL = isLocalPihApi()
  ? (process.env.REACT_APP_EMAIL_NOTIFICATION_LOCAL_URL || LOCAL_EMAIL_NOTIFICATION_DEFAULT).trim()
  : (
    process.env.REACT_APP_EMAIL_NOTIFICATION_BASE_URL ||
    process.env.REACT_APP_EMAIL_NOTIFICATION_URL ||
    LOCAL_EMAIL_NOTIFICATION_DEFAULT
  ).trim();

/** Login URL embedded in invitation / reset-password emails. */
export const PLATFORM_LOGIN_URL = (() => {
  const fromEnv = process.env.REACT_APP_PLATFORM_LOGIN_URL?.trim();
  if (fromEnv) return fromEnv;
  if (isLocalPihApi()) return LOCAL_PLATFORM_LOGIN_URL;
  const webapp = process.env.REACT_APP_WEBAPP_URL?.trim();
  if (webapp) {
    const base = webapp.replace(/\/$/, '');
    return base.endsWith('/login') ? base : `${base}/login`;
  }
  return LOCAL_PLATFORM_LOGIN_URL;
})();

export default {
  Auth: {
    region: REGION,
    userPoolId: USER_POOL_ID,
    userPoolWebClientId: USER_POOL_WEB_CLIENT_ID,
  },
};
